import { Component, input, OnInit } from '@angular/core';
import { ProductVariantGroupDto } from '../../dtos/product-variant.dto';

import { RouterLinkWithLang } from '../../directives/router-link-with-lang/router-link-with-lang.directive';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'product-variants',
  templateUrl: './product-variants.component.html',
  styleUrls: ['./product-variants.component.scss'],
  imports: [RouterLink, RouterLinkWithLang],
})
export class ProductVariantsComponent implements OnInit {

  readonly variantGroups = input<ProductVariantGroupDto[]>([]);
  readonly isBigSize = input<boolean>(false);

  constructor() { }

  ngOnInit(): void {
  }

}
